import Legal2 from "../../legal/documents/LegalTb.vue";
import DocumentList2 from "../documents/DocumentListTenn.vue";
import layouts from "../../../../layout";
export default {
  path: "/legaltb",
  name: "legal",
  component: Legal2,
  meta: {
    auth: true
  },
  redirect: {
    name: "legal-documentTB"
  },
  children: [
    {
      path: "documentsTB",
      name: "legal-documentTB",
      component: DocumentList2,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["legaltb", "documents"],
        index: true
      }
    }
  ]
};
